import { render, staticRenderFns } from "./ToolbarQuill.vue?vue&type=template&id=8c7a1198&"
import script from "./ToolbarQuill.vue?vue&type=script&lang=js&"
export * from "./ToolbarQuill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports